import {SetStateAction} from 'react';
import DialogComponent from '$components/DialogComponent';
import RejectAppointmentComponent from './component';

interface RejectAppointmentContainerProps {
  rejectAppointmentModal: boolean;
  setRejectAppointmentModal: React.Dispatch<SetStateAction<boolean>>;
  payment_id?: number;
  payment_status?: string;
}

const RejectAppointmentContainer: React.FC<RejectAppointmentContainerProps> = ({
  rejectAppointmentModal,
  setRejectAppointmentModal,
  payment_id,
  payment_status,
}) => {
  return (
    <DialogComponent
      open={rejectAppointmentModal}
      handleClose={setRejectAppointmentModal}
      dialogBody={
        <RejectAppointmentComponent
          rejectAppointmentModal={rejectAppointmentModal}
          setRejectAppointmentModal={setRejectAppointmentModal}
          paymentId={payment_id}
          paymentStatus={payment_status}
        />
      }
    />
  );
};

export default RejectAppointmentContainer;
